<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrIsoIcTetkikSoru from "./StrIsoIcTetkikSoru.vue";
import StrIsoIcTetkikSonuc from "./StrIsoIcTetkikSonuc.vue";
import StrIsoIcTetkikCevap from "./StrIsoIcTetkikCevap.vue";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, BirimSecimi, StrIsoIcTetkikSoru, StrIsoIcTetkikSonuc, StrIsoIcTetkikCevap
  },
  data() {
    return {
      title: "İç Tetkik",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "İç Tetkik",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
      },
      DetayId: null,
      OPersonelid: null,
      FormData: null,
      Tetkikid: null,
      Tetkik: null,
      KaliteRoleKontrol:false, 
    };
  },

  methods: {
    Get() {
        this.TableGet()
    },
    TableGet(){
      if(this.OPersonelid){
          var Filter = "&Personelid="+ this.OPersonelid
          if (this.Filter.Birimid != null) { Filter += "&Birimid=" + this.Filter.Birimid }

          this.ActionsFilterGet({ Service: "StrIsoIcTetkik", Page: this.Page, Filter: Filter }).then((res) => {
            this.TableData = res.Data;
            this.Page.PageDataSize = res.TotalCount;
          });
        }

    },

    Yayin(Data, durum) {
      Swal.fire({
        title: "Yayın " + (durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Faaliyetin yayın durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Yayin = durum
          this.Update("StrIsoIcTetkik", Data, "Yayın durumu değiştirildi.")
        }
      });

    },
    TarihSaatEkle(Data) {
      Swal.fire({
        title: "Tarih ve Saat bilgisi ekle",
        text: "Seçtiğiniz Faaliyetin Tarih ve Saat bilgisi değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) { 
          Data.Tarih = moment(new Date()).format("YYYY-MM-DD");
          Data.Saat = moment(new Date()).format("HH:mm");
          this.Update("StrIsoIcTetkik", Data, "Tarih ve Saat bilgisi değiştirildi.")
        }
      });

    },
    
    TetkikOnay(Data, durum) {
      Swal.fire({
        title: "Onay " + (durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Tetkiğin onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) { 
          if(durum == true){
            this.Post("strisoictetkikonay", {
              Tetkikid: Data.Id,
              Personelid: this.OPersonelid,
              Onay: true
            }, "Onay durumu değiştirildi.")
          }
          else{
            this.Delete('strisoictetkikonay', Data.Onayid) 
          }
        }
      });

    },
    TumuOnayKontrol(Data){

        var Birimpersonelonaylar = JSON.parse(Data.Birimpersonelonaylar)
        var Ictetkikonaylar = JSON.parse(Data.Ictetkikonaylar)
        var OnayDurumu = true
        for (let index = 0; index < Birimpersonelonaylar.length; index++) {
          const element = Birimpersonelonaylar[index]; 
          if(element.onay == false || element.onay == null){ OnayDurumu = false }
        }
        for (let index = 0; index < Ictetkikonaylar.length; index++) {
          const element = Ictetkikonaylar[index]; 
          if(element.onay == false || element.onay == null){ OnayDurumu = false }
        }
        return OnayDurumu
    },

    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoKaliteTemsilci")
      );
      if (YetkiSorgu.length != 0) this.KaliteRoleKontrol = true; 
    },
    
  },
  async created() {

    let Page = {
      PageNumber: "1",
      PageSize: "1"
    }
    let Filter = "&Eposta=" + this.UserEMail;
    var res = await this.ActionsFilterGet({
      Service: "OPersonel",
      Page: Page,
      Filter: Filter,
    })
    this.OPersonelid = res.Data[0].Id;
    this.TableGet()
    this.MuneRolesControl();

  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <BirimSecimi class="mb-3 col-md-3" title="Birim" :sutun="'0'" :title_position="'mb-3'"
                  :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid" :multiple="false"
                  :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" />

                <div class="col-sm-2 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="Get()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>


                <div class="col-sm-7 ">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4" v-b-modal.StrIsoIcTetkik
                      @click="(DataUpdate = StrIsoIcTetkikData), (AddEdit = 'Add')"><i
                        class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Tetkik Edilen Birim</th>
                      <th>Tetkik Tarihi ve Saati</th>
                      <th>Tetkik Yeri</th>
                      <th>Kalite Kontol İşlemler</th>
                      <th>Tetkik İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birim }}</th>
                      <td>{{ Data.Tarih | formatDateTable }} {{ Data.Saat }}</td>
                      <td>{{ Data.Yer }}</td>
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center"> 
                          <i v-b-tooltip.hover title="Yayınla" class="fas fa-check" @click="Yayin(Data, true)" v-if="!Data.Yayin"></i>
                          <i v-b-tooltip.hover title="Yayından Kaldır" class="fas fa-times" @click="Yayin(Data, false)" v-if="Data.Yayin"></i>  
                          <i v-b-tooltip.hover title="Sorular" class="fas fa-question" v-b-modal.StrIsoIcTetkikSoru @click="(Tetkikid = Data.Id)"></i> 
                          <i v-b-tooltip.hover title="Düzenle" class="fas fa-pencil-alt" v-b-modal.StrIsoIcTetkik
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')" v-if="Data.Kapanisonay != true"></i> 

                          <i v-b-tooltip.hover title="Sil" class="fas fa-trash-alt" @click="Delete('StrIsoIcTetkik', Data.Id)"
                            v-if="Data.Kapanisonay != true && KaliteRoleKontrol"></i> 
                        </div>
                      </td>
                      
                      <td v-if="!TumuOnayKontrol(Data)">
             

                        <div class="action-is w-100 d-flex justify-content-center align-items-center"
                        
                        v-if="Data.Birimpersonelleriids.includes(OPersonelid) || Data.Ictetkikciids.includes(OPersonelid)"
                        > 
                       

                        <i   v-b-tooltip.hover title="Onayla" class="fas fa-check" @click="TetkikOnay(Data, true)" v-if="!Data.Onay"></i>
                          <i v-b-tooltip.hover title="Onayı Kaldır"  class="fas fa-times" @click="TetkikOnay(Data, false)" v-if="Data.Onay"></i>  
                         
                          <i v-b-tooltip.hover title="Tarih ve Saat Ekle" class="fas fa-calendar-alt"
                            @click="TarihSaatEkle(Data)" v-if="!Data.Tarih"></i> 

                          <i v-b-tooltip.hover title="Soru Cevapla" class="fas fa-comment-dots" v-b-modal.StrIsoIcTetkikCevap
                            @click="(Tetkikid = Data.Id)" v-if="Data.Yayin"></i> 
                          <i v-b-tooltip.hover title="Sonuçlar" class="fas fa-file-alt" v-b-modal.StrIsoIcTetkikSonuc @click="(Tetkik = Data)" v-if="Data.Yayin"></i> 
                        </div>
                      </td>
                      <td v-else> İç Tetkik Tamamlanmıştır</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
      <StrIsoIcTetkikSoru :Tetkikid="Tetkikid" />
      <StrIsoIcTetkikSonuc :Tetkik="Tetkik" />
      <StrIsoIcTetkikCevap :Tetkikid="Tetkikid" :OPersonelid="OPersonelid" />

    </Layout>
  </Loader>
</template>
